module.exports = __webpack_public_path__ + "static/media/personal_folder_p2_1.8b3b7615.png";